"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUnitData = void 0;
var _react = require("react");
var _hooks = require("../../../hooks");
var _CetComponentsProvider = require("../../../providers/CetComponentsProvider");
var _http = require("../../../utilities/http");
var _urls = require("../../../utilities/urls");
var _TaskManager = require("../TaskManager.provider");
const useUnitData = () => {
  const {
    language
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    setIsUnitDataLoading,
    setUnitData,
    setIsUnitDataError,
    getLabel
  } = (0, _react.useContext)(_TaskManager.TaskManagerContext);
  const {
    isSessionDataReady,
    userId
  } = (0, _hooks.useSessionData)();
  const initUnitData = (0, _react.useCallback)(() => {
    if (isSessionDataReady && userId) {
      setIsUnitDataLoading(true);
      Promise.all([_http.http.get(`${_urls.ofakimApiUrl}/lmscp/getTaskFormUrls?cultureName=${language}&siteKey=ebag`).then(taskFormUrls => taskFormUrls || null).catch(error => {
        return null;
      }), _http.http.get(`${_urls.ofakimApiUrl}/lmscp/getHeadTopics?cultureName=${language}`).then(headTopics => headTopics || null).catch(error => {
        return null;
      }), _http.http.get(`${_urls.ofakimApiUrl}/lmscp/getTaskTypes?cultureName=${language}`) //TODO: can self learning be first?
      .then(taskTypes => {
        if (taskTypes) {
          Object.keys(taskTypes).forEach(typeKey => {
            if (getLabel(`task_types_${typeKey}`)) {
              taskTypes[typeKey] = getLabel(`task_types_${typeKey}`);
            }
          });
        }
        return taskTypes || null;
      }).catch(error => {
        return null;
      }), _http.http.get(`${_urls.ofakimApiUrl}/lmscp/getSchoolYear?date=${new Date().toISOString()}`).then(schoolYear => {
        if (schoolYear && schoolYear.endDate && schoolYear.startDate) {
          return {
            startDate: new Date(schoolYear.startDate),
            endDate: new Date(schoolYear.endDate)
          };
        }
      }).catch(error => {
        return null;
      })]).then(unitData => {
        // if (isActive?.current) {
        if (unitData && unitData[0] && unitData[1] && unitData[2] && unitData[3]) {
          setUnitData({
            taskFormUrls: unitData[0],
            headTopics: unitData[1],
            taskTypes: unitData[2],
            schoolYear: unitData[3]
          });
          setIsUnitDataError(false);
        } else {
          setUnitData(null);
          setIsUnitDataError(true);
        }
        setIsUnitDataLoading(false);
        // }
      });
    } else {
      setUnitData(null);
      setIsUnitDataError(false);
      setIsUnitDataLoading(false);
    }
  }, [getLabel, isSessionDataReady, language, setUnitData, setIsUnitDataError, setIsUnitDataLoading, userId]);
  return {
    initUnitData
  };
};
exports.useUnitData = useUnitData;